import React, { PureComponent } from 'react'
import { connect } from 'redaction'
import { compose, links } from 'helpers'
import cx from 'classnames'
import Media from 'local_modules/Media'
import actions from 'redux/actions'

import toggleOpen from 'local_modules/toggleOpen'

import Collapsible from 'components/ui/Collapsible/Collapsible'

import ToggleList from '../ToggleList/ToggleList'

import s from './UserLink.scss'

import defaultAvatar from './images/default.png'


class UserLink extends PureComponent {

  componentWillUnmount() {
    this.removeListener()
  }

  handleExit = () => {
    actions.me.exit()
      .then(() => actions.router.push(links.marketplace.customer.schedule))
  }

  handleOpen = () => {
    const { toggleOpen } = this.props

    this.addListener()
    toggleOpen()
  }

  handleClose = () => {
    const { toggleClose } = this.props

    toggleClose()
    this.removeListener()
  }

  addListener = () => {
    document.addEventListener('click', this.handleClose)
  }

  removeListener = () => {
    document.removeEventListener('click', this.handleClose)
  }

  render() {
    const { avatar, username, fio, isToggleActive } = this.props

    const _fio = fio || 'Пользователь'

    return (
      <div className={s.wrapper}>
        <div className={s.container}>
          <div
            className={cx(s.link, { [s.active]: isToggleActive })}
            onClick={isToggleActive ? this.handleClose : this.handleOpen}
          >
            <Media tablet>
              {
                (isTablet) => !isTablet && (
                  <img className={cx(s.avatar, s.exceptTablet)} src={avatar || defaultAvatar} title={_fio} />
                )
              }
            </Media>
            <Media mobile>
              {
                (isMobile) => !isMobile && (
                  <div className={s.text}>{_fio}</div>
                )
              }
            </Media>
          </div>
        </div>
        <Collapsible className={s.toggleListContainer} collapsed={!isToggleActive}>
          <ToggleList
            links={[
              {
                title: 'Выход',
                icon: 'logOff',
                onClick: this.handleExit,
              }
            ]}
          />
        </Collapsible>
      </div>
    )
  }
}


export default compose(
  connect({
    avatar: 'me.avatar',
    username: 'me.username',
    fio: 'me.fio',
  }),
  toggleOpen(),
)(UserLink)
